/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Control_Track_Fade_Out_LabelInputs */



/**
* | output |
* | --- |
* | "Fade up (ms)" |
*
* @param {Audio_Description_Export_Control_Track_Fade_Out_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_control_track_fade_out_label = /** @type {((inputs?: Audio_Description_Export_Control_Track_Fade_Out_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Control_Track_Fade_Out_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remontée (ms)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anheben (ms)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rialzo (ms)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Возврат (мс)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subida (ms)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("恢复时长（ms）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フェードアップ（ms）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ेड अप (ms)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Subida (ms)")
	return /** @type {LocalizedString} */ ("Fade up (ms)")
});